import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import type { AuthContextValue } from '../context/AuthContext';

/**
 * Zugriff auf den Auth-Context (Status, Benutzer, login/logout/refresh).
 * Darf nur unterhalb von <AuthProvider> verwendet werden.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth darf nur innerhalb von <AuthProvider> verwendet werden.');
  }
  return context;
}

export default useAuth;
